import { StaticImageData } from 'next/image'
import LleverageIcon from './icons/logo-lleverage.png'
import AomniIcon from './icons/logo-aomni.png'
import TrumpetIcon from './icons/logo-trumpet.png'
import SpekitIcon from './icons/logo-spekit.png'
import StoryblokIcon from './icons/logo-storyblok.png'
import SequenceIcon from './icons/logo-sequence.png'
import ConstantContactIcon from './icons/logo-constant-contact.png'
import QuickbaseIcon from './icons/logo-quickbase.png'
import AdeptiaIcon from './icons/logo-adeptia.png'

export type PricingPlansDataType = {
  title: string
  features: PricingPlansFeaturesDataType[]
  customers: PricingPlansCustomersDataType[]
}

type PricingPlansFeaturesDataType = {
  title: string
  tooltip?: string | null
}

type PricingPlansCustomersDataType = {
  name: string
  logo: StaticImageData
  width: string
  height: string
  tooltip: string
  url: string
}

export const pricingPlansData: PricingPlansDataType[] = [
  {
    title: 'Starter',
    features: [
      {
        title: 'Managed authentication',
        tooltip: null,
      },
      {
        title: 'Universal integrations',
        tooltip: null,
      },
      {
        title: 'Unlimited API calls',
        tooltip:
          'We charge a flat fee per Active Customer, with no extra costs for API calls or other usage metrics.',
      },
      {
        title: 'Unlimited integration instances',
        tooltip:
          'Deploy as many integration instances as needed – we charge per Active Customer, not per instance.',
      },
      {
        title: 'Unlimited users',
        tooltip:
          'Your customers can have unlimited users accessing integrations – we charge per Active Customer, not per individual user.',
      },
      {
        title: 'Standard support',
        tooltip: null,
      },
      {
        title: 'SOC 2 Type 2 certification',
        tooltip: null,
      },
      {
        title: '2 workspaces',
        tooltip: null,
      },
      {
        title: 'Up to 10 integrations',
        tooltip:
          'Add more anytime – costs will be prorated for the remainder of your contract term.',
      },
    ],
    customers: [
      {
        name: 'Lleverage',
        logo: LleverageIcon,
        width: '23px',
        height: '23px',
        url: 'https://www.lleverage.ai/',
        tooltip: 'Raised $2m',
      },
      {
        name: 'Aomni',
        logo: AomniIcon,
        width: '28px',
        height: '28px',
        url: 'https://www.aomni.com/',
        tooltip: 'Boostrapped',
      },
      {
        name: 'Trumpet',
        logo: TrumpetIcon,
        width: '31px',
        height: '16px',
        url: 'https://www.sendtrumpet.com/',
        tooltip: 'Raised $9.5m',
      },
    ],
  },
  {
    title: 'Pro',
    features: [
      {
        title: 'All Starter features, plus:',
        tooltip: null,
      },
      {
        title: 'Multiple workspaces',
        tooltip: null,
      },
      {
        title: 'Custom connectors',
        tooltip: null,
      },
      {
        title: 'Real-time Slack support',
        tooltip: null,
      },
      {
        title: 'Implementation services',
        tooltip: null,
      },
      {
        title: 'Custom connector development',
        tooltip: null,
      },
      {
        title: 'Integration advisory',
        tooltip: null,
      },
      {
        title: 'Up to 100 integrations',
        tooltip:
          'Add more anytime – costs will be prorated for the remainder of your contract term.',
      },
    ],
    customers: [
      {
        name: 'Spekit',
        logo: SpekitIcon,
        width: '23px',
        height: '27px',
        url: 'https://www.spekit.com/',
        tooltip: 'Raised $60m',
      },
      {
        name: 'Storyblok',
        logo: StoryblokIcon,
        width: '23px',
        height: '26px',
        url: 'https://www.storyblok.com/',
        tooltip: 'Raised $138m',
      },
      {
        name: 'Sequence',
        logo: SequenceIcon,
        width: '17px',
        height: '23px',
        url: 'https://www.sequencehq.com/',
        tooltip: 'Backed by a16z',
      },
    ],
  },
  {
    title: 'Ultimate',
    features: [
      {
        title: 'All Pro features, plus:',
        tooltip: null,
      },
      {
        title: 'Unlimited integrations',
        tooltip: null,
      },
      {
        title: 'Dedicated real-time support',
        tooltip: null,
      },
      {
        title: 'On-premise deployment available',
        tooltip: null,
      },
      {
        title: 'Single sign-on (SSO)',
        tooltip: null,
      },
      {
        title: 'Role-based access',
        tooltip: null,
      },
      {
        title: 'Audit logs',
        tooltip: null,
      },
      {
        title: '... and more',
        tooltip: null,
      },
    ],
    customers: [
      {
        name: 'Constant Contact',
        logo: ConstantContactIcon,
        width: '24px',
        height: '24px',
        url: 'https://www.constantcontact.com/',
        tooltip: '$1bn+ valuation - NASDAQ listed',
      },
      {
        name: 'Quickbase',
        logo: QuickbaseIcon,
        width: '18px',
        height: '24px',
        url: 'https://www.quickbase.com/',
        tooltip: 'Raised $70m+',
      },
      {
        name: 'Adeptia',
        logo: AdeptiaIcon,
        width: '27px',
        height: '24px',
        url: 'https://www.adeptia.com/',
        tooltip: 'Raised $70m+',
      },
    ],
  },
]
